import { opportunityService } from '../../helpers/services/opportunity.service'
import { sharedHelper } from '@/utils'

export const state = {
  list: [],
  pagination: {},
  pipeline: [],
  details: {},
  status: { list: true, detail: true, save: true },
  lastError: null,
}

export const OPPORTUNITY_MODULE = 'opportunity'

export const GET_ALL_OPPORTUNITIES = 'getAllOpportunities'
export const GET_OPPORTUNITY_PIPELINE = 'getOpportunityPipeline'
export const GET_OPPORTUNITY_STATS = 'getOpportunityStats'
export const GET_OPPORTUNITY = 'getOpportunity'
export const CREATE_OPPORTUNITY = 'createOpportunity'
export const UPDATE_OPPORTUNITY = 'updateOpportunity'
export const DELETE_OPPORTUNITY = 'deleteOpportunity'
export const SET_OPPORTUNITY_STAGE = 'setOpportunityStage'
export const WIN_OPPORTUNITY = 'winOpportunity'
export const LOSE_OPPORTUNITY = 'loseOpportunity'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const PIPELINE_SUCCESS = 'pipelineSuccess'
const DETAIL_SUCCESS = 'detailSuccess'

function run(commit, type, promise, failValue = null) {
  commit(REQUESTING, type)
  return promise.then((r) => {
    commit(SUCCESS); return r
  }).catch((e) => {
    sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    commit(FAILURE, e)
    return failValue
  })
}

export const actions = {
  [GET_ALL_OPPORTUNITIES]({ commit }, { filter } = {}) {
    commit(REQUESTING, 'list')
    return opportunityService.getAll(filter || {}).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e)
    })
  },
  [GET_OPPORTUNITY_STATS]() {
    return opportunityService.getStats().catch((e) => {
      // Cosmetic counters — a failure must not blank the list beneath them.
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
      return null
    })
  },
  [GET_OPPORTUNITY_PIPELINE]({ commit }) {
    return opportunityService.getPipeline().then((r) => {
      commit(PIPELINE_SUCCESS, r); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_OPPORTUNITY]({ commit }, { uuid }) {
    commit(REQUESTING, 'detail')
    return opportunityService.get(uuid).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e)
    })
  },
  [CREATE_OPPORTUNITY]({ commit }, { payload }) {
    return run(commit, 'save', opportunityService.create(payload))
  },
  [UPDATE_OPPORTUNITY]({ commit }, { uuid, payload }) {
    return run(commit, 'save', opportunityService.update(uuid, payload))
  },
  [DELETE_OPPORTUNITY]({ commit }, { uuid }) {
    return run(commit, 'save', opportunityService.remove(uuid).then(() => true), false)
  },
  [SET_OPPORTUNITY_STAGE]({ commit }, { uuid, stage }) {
    return run(commit, 'save', opportunityService.setStage(uuid, stage))
  },
  [WIN_OPPORTUNITY]({ commit }, { uuid, payload }) {
    return run(commit, 'save', opportunityService.markWon(uuid, payload || {}))
  },
  [LOSE_OPPORTUNITY]({ commit }, { uuid, payload }) {
    return run(commit, 'save', opportunityService.markLost(uuid, payload))
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    state.list = data?.data || []
    state.pagination = data?.pagination || {}
  },
  [PIPELINE_SUCCESS](state, data) {
    state.pipeline = data?.data || []
  },
  [DETAIL_SUCCESS](state, data) {
    state.details = data?.data || {}
  },
  [FAILURE](state, error) {
    state.status = { list: true, detail: true, save: true }
    state.lastError = error || null
  },
  [REQUESTING](state, type) {
    state.status[type] = false
    state.lastError = null
  },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
